<template>
    <section class="g-container || o-band">
        <div class="o-container">

            <app-intro class="u-d-flex align-items-center justify-content-between">
                <h3 class="u-mb-0">Licenties</h3>

                <router-link :to="`/admin/subscriptions/${$route.params.ProductID}/update`" class="c-link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18.589" height="12.388" viewBox="0 0 18.589 12.388">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                            <path d="M17.589 6.223H4.714"/>
                            <path d="M7.439 10.989L1.001 6.195l6.438-4.8" stroke-linejoin="round"/>
                            <path d="M7.439 10.99L5.894 6.195l1.545-4.8" stroke-linejoin="round"/>
                        </g>
                    </svg>

                    Terug naar abonnement
                </router-link>
            </app-intro>

            <transition-group class="" name="fade" tag="section" v-if="licenses.length">
                <div class="table table--bordered" key="table">
                    <div class="table__thead">
                        <div class="table__tr" v-for="licence in licenses" :key="`thead-${licence.LicentieID}`">
                            <div class="table__th">Product</div>
                            <div class="table__th">Device</div>
                            <div class="table__th">Startdatum</div>
                            <div class="table__th"></div>
                        </div>
                    </div>
                    <div class="table__tbody">
                        <div class="table__tr" v-for="licence in licenses" :key="`tbody-${licence.LicentieID}`">
                            <div class="table__td">{{ licence.Productnaam }}</div>
                            <div class="table__td">{{ licence.Licentienaam }}</div>
                            <div class="table__td">{{ licence.Startdatum }}</div>
                            <div class="table__td || u-text-right">
                                <a href="#0" class="c-link c-link--danger || u-font-weight-normal" :data-sub-id="licence.AbonnementID" :data-license-id="licence.LicentieID" :data-product-id="licence.ProductID" :data-licence="licence.Licentienaam" @click.prevent="showModalConfirm">
                                    Stopzetten
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 9.045 9.045">
                                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                                            <path d="M1.415 1.414L7.63 7.631"/>
                                            <path d="M7.632 1.414L1.415 7.631"/>
                                        </g>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <modal key="modal-confirm" v-show="modalConfirm.visible" @close="closeModalConfirm">
                    <template v-slot:header>
                        <h4 class="u-mb-0">Weet je zeker dat je deze licentie wilt stopzetten?</h4>
                        <span class="delta || u-font-weight-normal || u-text-primary">{{ modal.license }}</span>
                    </template>

                    <template v-slot:body>
                        <form v-on:submit.prevent="stopLicense" class="form">

                            <div class="u-d-flex justify-content-end">
                                <!--<a href="#0" class="c-btn c-btn&#45;&#45;info">Sluiten</a>-->

                                <button type="submit" href="#0" class="c-btn c-btn--danger">
                                    Ja, licentie stopzetten

                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 9.045 9.045">
                                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                                            <path d="M1.415 1.414L7.63 7.631"/>
                                            <path d="M7.632 1.414L1.415 7.631"/>
                                        </g>
                                    </svg>
                                </button>
                            </div>
                        </form>
                    </template>
                </modal>
            </transition-group>

            <div v-else>
                <p>Geen licenties gevonden</p>
            </div>

            <loading v-bind:nodes="licenses">Bezig met laden van de licenties...</loading>

        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import AppIntro from '../../components/app/AppIntro.vue';
    import Modal from '../../components/Modal.vue';
    import Loading from '../../components/Loading.vue';
    import normalizeFormData from '../../helpers/normalizeFormData';

    export default {
        components: { AppIntro, Loading, Modal },
        data () {
            return {
                modal: {
                    visible: false,
                    LicentieID: '',
                    ProductID: '',
                    AbonnementID: '',
                    license: '',
                },
                modalConfirm: {
                    visible: false,
                },
            };
        },
        computed: {
            ...mapState({
                licenses: (state) => state.license.list,
            }),
        },
        created () {
            this.$store.dispatch('license/get', this.$route.params.AbonnementID);
        },
        methods: {
            showModalConfirm ($event) {
                this.modal.ProductID = $event.target.dataset.productId;
                this.modal.LicentieID = $event.target.dataset.licenseId;
                this.modal.AbonnementID = $event.target.dataset.subId;
                this.modal.license = $event.target.dataset.license;
                this.modalConfirm.visible = true;
            },
            closeModalConfirm () {
                this.modal.license = '';
                this.modalConfirm.visible = false;
            },
            async stopLicense (e) {
                const id = this.modal.LicentieID;
                const data = normalizeFormData(e.target);

                await this.$store.dispatch('license/stop', { id, data });

                this.$store.dispatch('license/get', this.$route.params.AbonnementID);
                this.closeModalConfirm();
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    .table {
        /*@include media-breakpoint-only(sm) {
            grid-template-columns: rem(150) 1fr;
            margin: 0;
            max-width: 100%;
        }*/

        &__tr {
            @include media-breakpoint-up(md) {
                grid-template-columns: 0.75fr 1.5fr 1.5fr rem(175);
            }
        }
    }
</style>
